// The same set the identity service accepts for a login (ASP.NET Identity's default
// AllowedUserNameCharacters). The service refuses anything else, so the form says so first.
const SUPPORTED = /^[A-Za-z0-9\-._@+]$/;

/**
 * Characters in an email address that a login cannot contain, each listed once in the
 * order typed. Whitespace is reported as the word "space" so it is visible in a message.
 *
 * @param {unknown} email
 * @returns {string[]}
 */
export function unsupportedEmailCharacters(email) {
  if (typeof email !== "string") return [];

  const labels = Array.from(email.trim())
    .filter((character) => !SUPPORTED.test(character))
    .map((character) => (/\s/.test(character) ? "space" : character));
  return [...new Set(labels)];
}

/**
 * @param {unknown} email
 * @returns {string|null} the message to show, or null when every character is supported
 */
export function unsupportedEmailCharactersMessage(email) {
  const unsupported = unsupportedEmailCharacters(email);
  if (unsupported.length === 0) return null;

  return unsupported.length === 1
    ? `This email address contains a character we do not support: ${unsupported[0]}`
    : `This email address contains characters we do not support: ${unsupported.join(" ")}`;
}

/** Yup test for the email field of a form that creates a login: `.test(supportedEmailCharacters)`. */
export const supportedEmailCharacters = {
  name: "supported-email-characters",
  test(value) {
    const message = unsupportedEmailCharactersMessage(value);
    return message ? this.createError({ message }) : true;
  },
};
